import { FlexProps, TextProps } from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { MdInfo } from 'react-icons/md';
import { MFlex, MIcon, MText, MTooltip } from '../../../../components/Monetize';

interface HeaderCellTextProps extends FlexProps {
  isRequired?: boolean;
  textProps?: TextProps;
  tooltipLabel?: ReactNode;
  additionalNode?: ReactNode;
  isOverlay?: boolean;
  children?: ReactNode;
}

const HeaderCellText = ({
  children,
  isRequired,
  textProps = {},
  tooltipLabel,
  additionalNode,
  ...rest
}: HeaderCellTextProps): React.ReactElement => {
  return (
    <>
      <MFlex fontWeight="600" alignItems={'center'} {...rest}>
        <MText fontSize="xs" {...textProps}>
          {children}
        </MText>
        {isRequired && (
          <MText color="tRed.cinnabar" ml="1" {...textProps}>
            *
          </MText>
        )}
        {tooltipLabel && (
          <MTooltip label={tooltipLabel} placement="bottom-start">
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              <MIcon
                display={'flex'}
                as={MdInfo}
                w="4"
                h="4"
                ml={2}
                cursor="pointer"
              />
            </span>
          </MTooltip>
        )}
      </MFlex>
      {additionalNode && <MFlex mt={2}>{additionalNode}</MFlex>}
    </>
  );
};

export default HeaderCellText;
